import React, {useContext} from "react";
import {authContext} from "../providers/auth";
import {Loading} from "../components/Loading";
import {ApiProvider} from "../providers/api";
import {ResourceProvider} from "../providers/resources";
import {ShiftsProvider} from "../providers/shifts";
import {SchedulerPage} from "./Scheduler";
import { ResourceViewProvider } from "../providers/resourceView";
import { ErrorsModalProvider } from "../components/scheduler/Events/ErrorModal";
import { RsoConfigurationProvider } from "../providers/rsoConfiguration";
import { BoardContextProvider } from "../providers/boardContext";

const Providers = ()=> {
    const {isAuthed} = useContext(authContext)
    // if(!isAuthed){
    //     return (<Loading label={'Logging in...'}/>)
    // }
    return (
        <>
            <ApiProvider>
                <BoardContextProvider>
                    <ResourceProvider>
                        <ShiftsProvider>
                            <RsoConfigurationProvider>
                                <ErrorsModalProvider>
                                    <ResourceViewProvider>
                                        <SchedulerPage/>
                                    </ResourceViewProvider>
                                </ErrorsModalProvider>
                            </RsoConfigurationProvider>
                        </ShiftsProvider>
                    </ResourceProvider>
                </BoardContextProvider>
            </ApiProvider>
        </>


    )
}

export {Providers}
